import { render, staticRenderFns } from "./HeaderPreview.vue?vue&type=template&id=0c7b3158&scoped=true&"
import script from "./HeaderPreview.vue?vue&type=script&lang=js&"
export * from "./HeaderPreview.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPreview.vue?vue&type=style&index=0&id=0c7b3158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b3158",
  null
  
)

export default component.exports